export const rolesSchema = {
  fields: [
    {
      name: 'nombre',
      type: 'text',
      label: 'Nombre del Rol',
      required: true,
      placeholder: 'ej: ADMINISTRADOR',
      gridSpan: 'auto',
      format: 'uppercase'
    },
    {
      name: 'descripcion',
      type: 'textarea',
      label: 'Descripción',
      required: false,
      placeholder: 'ej: Rol con permisos administrativos completos',
      gridSpan: 'full'
    },
    {
      name: 'activo',
      type: 'checkbox',
      label: 'Rol activo',
      required: false,
      gridSpan: 'full'
    }
  ]
};